const payrollFilters = {
  payFrequencyId: null,
  dateBegin: null,
  dateEnd: null,
  businessEntityId: null,
  clientId: null,
  showDetails: true,
  useCustomRange: false
}

// The filters a payroll report was searched with, as opposed to the ones currently in the inputs.
// Show Details is deliberately absent: it picks which columns render rather than which rows come
// back, so it never describes a search.
const appliedPayrollFilters = {
  payFrequencyId: null,
  dateBegin: null,
  dateEnd: null,
  businessEntityId: null,
  clientId: null,
  useCustomRange: false
}

export const getAppliedPayrollFiltersModel = () => Object.assign({}, appliedPayrollFilters)

export default () => Object.assign({}, payrollFilters)
